import axiosClient from "api/axios_client.js";

const BASE = "/knowledge-management/knowledge-configuration/knowledge-article";

const apiKnowledgeArticle = {
  create: (payload) => axiosClient.post(`${BASE}/create`, payload),
  update: (id, payload) => axiosClient.put(`${BASE}/update/${id}`, payload),
  getById: (id) => axiosClient.get(`${BASE}/get-by-id/${id}`),
  getAll: (payload) => axiosClient.post(`${BASE}/get-all`, payload),
  delete: (ids) => axiosClient.delete(`${BASE}/delete`, { data: { ids } }),

  // Knowledge-base dropdown (article form + filter) and article likers (preview dialog)
  getKnowledgeBasesForDropdown: () => axiosClient.get(`/knowledge-management/knowledge-configuration/knowledge-base/get-all`),
  getLikers: (contentId) => axiosClient.get(`/knowledge-management/knowledge-configuration/knowledge-hub/content/${contentId}/likers`),
};

export default apiKnowledgeArticle;
